import React from 'react';

interface CouponMessagesProps {
  couponError?: string;
  localCouponError: string;
  showRemovedMessage: boolean;
  couponApplied: boolean;
  onRemoveCoupon: () => void;
}

export const CouponMessages: React.FC<CouponMessagesProps> = ({
  couponError,
  localCouponError,
  showRemovedMessage,
  couponApplied,
  onRemoveCoupon,
}) => {
  return (
    <>
      {/* Mensagem de erro */}
      {(couponError || localCouponError) && (
        <p className="text-red-500 text-xs mt-1 flex items-center">
          <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
          {localCouponError || couponError}
        </p>
      )}
      
      {/* Mensagem de cupom removido */}
      {showRemovedMessage && (
        <p className="text-blue-500 text-xs mt-1 flex items-center">
          <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
          Cupom removido com sucesso!
        </p>
      )}
      
      {/* Mensagem de cupom aplicado */}
      {couponApplied && !couponError && !localCouponError && !showRemovedMessage && (
        <div className="flex items-center justify-between mt-1">
          <p className="text-green-600 text-xs flex items-center">
            <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            Cupom aplicado com sucesso!
          </p>
          <button
            onClick={onRemoveCoupon}
            className="text-xs text-red-500 hover:text-red-700 underline transition-colors"
            title="Remover cupom"
          >
            Remover
          </button>
        </div>
      )}
    </>
  );
}; 